import React, {useContext, useEffect, useState} from 'react';
import BlockWrapper from 'app/Components/Shared/BlockWrapper';
import {ComponentProps} from '@episerver/spa-core/EpiComponent';
import OperationBoxItemBlockData from 'Models/Content/OperationBoxItemBlockData';
import OperationBoxItemsBlockData from 'Models/Content/OperationBoxItemsBlockData';
import OperationBoxItem, {OperationBoxItemProps} from './OperationBoxItem';
import {getBackgroundImageProps} from 'app/utilities/ImageProps';
import TheCounterContext, {categoryFilterFunc} from 'app/Components/Page/TheCounterPage/TheCounterContext';

const OperationBoxItemsBlock = (props: ComponentProps<OperationBoxItemsBlockData>) => {
  const {data, context} = props;
  const [selectedCategory] = useContext(TheCounterContext) ?? [null];
  const [items, setItems] = useState<OperationBoxItemProps[]>(null);

  useEffect(() => {
    if (!data.operationBoxItems?.expandedValue) return setItems(null);
    const items = (data.operationBoxItems.expandedValue as OperationBoxItemBlockData[])
      .filter((item) => categoryFilterFunc(item, selectedCategory))
      .map(({title, link, titleAsImage}) => ({
        href: link.value,
        title: title.value,
        image: getBackgroundImageProps(titleAsImage, context),
      }));

    setItems(items);
  }, [data.operationBoxItems, selectedCategory]);

  return (
    <BlockWrapper props={props}>
      <div className='OperationBoxItemsBlock__items'>
        {items?.map((itemProps, i) => (
          <OperationBoxItem key={i} {...itemProps} />
        ))}
      </div>
    </BlockWrapper>
  );
};

export default OperationBoxItemsBlock;
